/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_4_Paragraphs_0Inputs */

const en_gc_search_guides_gridcraft_vs_excel_sections_4_paragraphs_0 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_4_Paragraphs_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A personal expense workbook has a short list of categories, a few totals and one chart. You are the only editor and can easily check the result. This is a reasonable task for evaluating GridCraft: start from a copy, make a change and reopen the saved output. The important questions are whether the calculations remain correct and whether you find the workflow comfortable enough to repeat each week.`)
};

const zh_gc_search_guides_gridcraft_vs_excel_sections_4_paragraphs_0 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_4_Paragraphs_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`个人支出表可能只有少量分类、几个合计和一张图表，由你一人编辑，结果也容易检查。这类任务适合用来评估 GridCraft：从副本开始，修改后重新打开保存结果。重点是计算是否正确，以及这套操作是否适合每周重复使用。`)
};

/**
* | output |
* | --- |
* | "A personal expense workbook has a short list of categories, a few totals and one chart. You are the only editor and can easily check the result. This is a re..." |
*
* @param {Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_4_Paragraphs_0Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_vs_excel_sections_4_paragraphs_0 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_4_Paragraphs_0Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_4_Paragraphs_0Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_vs_excel_sections_4_paragraphs_0(inputs)
	return zh_gc_search_guides_gridcraft_vs_excel_sections_4_paragraphs_0(inputs)
});
export { gc_search_guides_gridcraft_vs_excel_sections_4_paragraphs_0 as "gc.search_guides.gridcraft_vs_excel.sections.4.paragraphs.0" }